import { format, parseISO } from 'date-fns';
import React from 'react';
import { graphql, Link } from 'gatsby';
import Img from 'gatsby-image';
import useBlog from '../hooks/useBlog';
import { Helmet } from 'react-helmet';
import readingTime from 'reading-time';

function Project({ data: { blog } }) {
  const { slug, title, description, publishedAt, coverImage, category, shortDescription } = blog;

  const { allBlogs } = useBlog();

  const filteredBlogs = allBlogs?.slice(0, 4);

  const imageUrl = `https://${coverImage.fluid.src.substring(2)}`;

  return (
    <div className='bg-white'>
      <Helmet>
        <link
          rel='stylesheet'
          href='https://cdn.jsdelivr.net/npm/@tailwindcss/typography@0.4.x/dist/typography.min.css'
        />
        <title>{title} | Solaric</title>
        <meta name='robots' content='follow, index' />
        <meta content={shortDescription} name='description' />
        <meta property='og:url' content={`https://solaricglobal.com/blog/${slug}`} />
        <link rel='canonical' href={`https://solaricglobal.com/blog/${slug}`} />
        {/* Open Graph / Facebook */}
        <meta property='og:type' content='website' />
        <meta property='og:site_name' content='Solaric Global' />
        <meta property='og:description' content={shortDescription} />
        <meta property='og:title' content={title} />
        <meta property='og:image' content={imageUrl} />
        {/* Twitter */}
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:site' content='@Solaric' />
        <meta name='twitter:title' content={title} />
        <meta name='twitter:description' content={shortDescription} />
        <meta name='twitter:image' content={imageUrl} />
        <meta property='article:published_time' content={format(parseISO(publishedAt), 'MMMM dd, yyyy')} />
      </Helmet>
      <div style={{ paddingTop: '4rem' }}>
        <div className='container'>
          <div className='blog-container row'>
            <article className='prose xl:prose-xl col-xl-8'>
              <h1 className='mainTitle' style={{ margin: '0', lineHeight: '1' }}>
                {title}
              </h1>
              <div className='blogCover'>
                <Img
                  fluid={coverImage.fluid}
                  className='cover'
                  style={{ width: '100%', margin: '0', paddingTop: '0' }}
                  objectFit='contain'
                  alt={title}
                />
                <div className='blog-cat'>{category}</div>
              </div>
              <div className='blogInfo'>
                <p>Published at - {format(parseISO(publishedAt), 'MMMM dd, yyyy')}</p>
                <p>{readingTime(description.childMarkdownRemark.html).text}</p>
              </div>

              <div dangerouslySetInnerHTML={{ __html: description.childMarkdownRemark.html }}></div>
            </article>
            <div className='d-none d-xl-block col-xl-4 recent-container'>
              <p className='recentTitle'>Recent Posts</p>
              {filteredBlogs.map((blog, idx) => (
                <Link
                  to={blog.externalLink ? blog.externalLink : `/blog/${blog.slug}`}
                  target={blog.externalLink ? '_blank' : ''}
                  key={idx}
                  className='recentCard'
                >
                  <Img
                    fluid={blog.coverImage.fluid}
                    style={{ height: '150px', margin: '0', paddingTop: '0' }}
                    objectFit='contain'
                    alt={blog.title}
                  />
                  <p className='title'>{blog.title}</p>
                  <p className='time'>{format(parseISO(publishedAt), 'MMMM dd, yyyy')}</p>
                </Link>
              ))}
            </div>
          </div>
          <div className='d-flex justify-content-center'>
            <Link to='/blog' className='back-to-projects'>
              Back to all Posts
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export const query = graphql`
  query($slug: String!) {
    blog: contentfulBlog(slug: { eq: $slug }) {
      category
      slug
      title
      publishedAt
      shortDescription
      description {
        childMarkdownRemark {
          html
        }
      }
      coverImage {
        fluid {
          src
        }
      }
    }
  }
`;

export default Project;
